__turbopack_context__.v({
  "container": "CookiePopUp-module-scss-module__espHIW__container",
  "privacyPolicy": "CookiePopUp-module-scss-module__espHIW__privacyPolicy",
});
